export const GET_POS_ENTRY_MODE = "GET_POS_ENTRY_MODE"
export const GET_POS_ENTRY_MODE_SUCCESS = "GET_POS_ENTRY_MODE_SUCCESS"
export const GET_POS_ENTRY_MODE_FAIL = "GET_POS_ENTRY_MODE_FAIL"

export const UPDATE_POS_ENTRY_MODE = "UPDATE_POS_ENTRY_MODE"
export const UPDATE_POS_ENTRY_MODE_SUCCESS = "UPDATE_POS_ENTRY_MODE_SUCCESS"
export const UPDATE_POS_ENTRY_MODE_FAIL = "UPDATE_POS_ENTRY_MODE_FAIL"

export const POS_ENTRY_MODE_API_ERROR = "API_ERROR"
